// extracted by mini-css-extract-plugin
export default {"richText":"richText_richText__fc9Va","ProseMirror-selectednode":"richText_ProseMirror-selectednode__h8FUp"};